<div class="modal-header">
  <h4 class="modal-title">
    <i class="fa fa-download text-primary me-2"></i>
    {{ 'companyProfile.membershipPlans.exportMembers.title' | translate }}
  </h4>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | translate" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <p class="text-muted mb-5">{{ 'companyProfile.membershipPlans.exportMembers.description' | translate }}</p>

  <!-- Select All -->
  <div class="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
    <div class="form-check">
      <input class="form-check-input" type="checkbox"
             [checked]="allSelected"
             (change)="toggleAll($event)"
             id="selectAll">
      <label class="form-check-label fw-bold" for="selectAll">
        {{ 'companyProfile.membershipPlans.exportMembers.selectAll' | translate }}
      </label>
    </div>
    <span class="badge badge-light-primary">
      {{ 'companyProfile.membershipPlans.exportMembers.plansSelected' | translate:{ count: selectedPlansCount, members: totalSelectedMembers } }}
    </span>
  </div>

  <!-- Plan List -->
  <div class="plan-list">
    @for (ps of planSelections; track ps.plan.plan_id) {
      <div class="plan-item" [class.selected]="ps.selected">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 [(ngModel)]="ps.selected"
                 [id]="'plan-' + ps.plan.plan_id">
          <label class="form-check-label" [for]="'plan-' + ps.plan.plan_id">
            <span class="plan-name">{{ ps.plan.name }}</span>
          </label>
        </div>
        <div class="plan-meta">
          <span class="badge" [class.badge-primary]="ps.plan.coverage === 'individual'"
                             [class.badge-success]="ps.plan.coverage === 'family'">
            {{ ps.plan.coverage | titlecase }}
          </span>
          <span class="member-count">{{ ps.memberCount }} member{{ ps.memberCount !== 1 ? 's' : '' }}</span>
        </div>
      </div>
    }
  </div>

  <!-- Export Options -->
  <div class="export-options mt-5">
    <h6 class="fw-bold mb-3">{{ 'companyProfile.membershipPlans.exportMembers.exportOptions' | translate }}</h6>

    <!-- Format Selection -->
    <div class="format-selection mb-4">
      <label class="format-option" [class.selected]="exportFormat === 'pdf'">
        <input type="radio" name="format" value="pdf" [(ngModel)]="exportFormat">
        <div class="format-content">
          <i class="fa fa-file-pdf"></i>
          <div>
            <strong>{{ 'companyProfile.membershipPlans.exportMembers.formatPdf' | translate }}</strong>
            <small>{{ 'companyProfile.membershipPlans.exportMembers.formatPdfDesc' | translate }}</small>
          </div>
        </div>
      </label>
      <label class="format-option" [class.selected]="exportFormat === 'csv'">
        <input type="radio" name="format" value="csv" [(ngModel)]="exportFormat">
        <div class="format-content">
          <i class="fa fa-file-csv"></i>
          <div>
            <strong>{{ 'companyProfile.membershipPlans.exportMembers.formatCsv' | translate }}</strong>
            <small>{{ 'companyProfile.membershipPlans.exportMembers.formatCsvDesc' | translate }}</small>
          </div>
        </div>
      </label>
    </div>

    <div class="form-check">
      <input class="form-check-input" type="checkbox"
             [(ngModel)]="includeExpired"
             id="includeExpired">
      <label class="form-check-label" for="includeExpired">
        {{ 'companyProfile.membershipPlans.exportMembers.includeExpired' | translate }}
      </label>
    </div>
  </div>
</div>

<div class="modal-footer">
  <app-button
    [variant]="'ghost'"
    [label]="'common.cancel' | translate"
    (clicked)="activeModal.dismiss()"
  />
  <app-button
    [variant]="'primary'"
    [label]="exporting ? ('companyProfile.membershipPlans.exportMembers.exporting' | translate) : (exportFormat === 'pdf' ? ('companyProfile.membershipPlans.exportMembers.exportPdf' | translate) : ('companyProfile.membershipPlans.exportMembers.exportCsv' | translate))"
    [iconClass]="exportFormat === 'pdf' ? 'fa fa-file-pdf' : 'fa fa-file-csv'"
    [disabled]="selectedPlansCount === 0 || exporting"
    [loading]="exporting"
    (clicked)="exportMembers()"
  />
</div>
